
  import Vue from 'vue'
  import FilterChipTemplate from './FilterChipTemplate.vue';

  export default Vue.extend({
    name: 'NumberFilter',

    components: {
      FilterChipTemplate
    },
    props: ['value', 'label', 'attributes', 'mandatory', 'always', 'small'],
    data: (_this: any): any => ({
      rules: [
        (v: string) => !!v || _this.requiredError
      ],
      localNumber: _this.value[_this.attributes['value']],
      localFilters: _this.value as any,
      menu: false,
    }),
    created() {
      // s
    },
    methods: {
      onSave() {
        this.localFilters[this.attributes['value']] = this.localNumber;
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onReset() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onChipRemove() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.$emit('delete');
      }
    },
    watch: {
      value() {
        this.localFilters = { ...this.value };
        this.localNumber = this.localFilters[this.attributes['value']];
      },
      menu() {
        if(!this.menu) {
          this.localNumber = this.localFilters[this.attributes['value']];
        }
      }
    },
    computed: {
      filterRepr(): any {
        return this.localFilters[this.attributes['value']] ?? '';
      },
      isValid(): any {
        return this.mandatory ? this.rules.reduce((acc: boolean, rule: any) => acc ? rule(this.localNumber)===true : acc, true) : true;
      },
      requiredError(): any {
        return this.$t('required');
      },
    }
  })
